import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, BarChart3, Timer, ChevronRight } from 'lucide-react'; /* [PATCH pregled-dela v4] */

/* [PATCH superadmin-ploscice v1]
   Razdelilnik superadmina. Dosedanja vsebina te strani je v celoti
   preseljena v SuperadminBazePage.tsx (ruta /superadmin/baze).
   Poraba in prostor ostaja SuperadminPorabaPage.tsx (/superadmin/poraba),
   nedotaknjena — spremeni se samo pot do nje (prej gumb v glavi, zdaj ploscica). */

/* Polno obarvane menijske kartice — enak vzorec kot DashboardPage.tsx */
const menuStyle: Record<string, { card: string; chip: string; chev: string }> = {
  violet: {
    card: 'bg-violet-50 dark:bg-violet-500/15 border-violet-200 dark:border-violet-500/30 hover:border-violet-400 dark:hover:border-violet-500/60',
    chip: 'bg-violet-100 dark:bg-violet-500/25 text-violet-600 dark:text-violet-300',
    chev: 'text-violet-400 group-hover:text-violet-600 dark:group-hover:text-violet-300',
  },
  sky: {
    card: 'bg-sky-50 dark:bg-sky-500/15 border-sky-200 dark:border-sky-500/30 hover:border-sky-400 dark:hover:border-sky-500/60',
    chip: 'bg-sky-100 dark:bg-sky-500/25 text-sky-600 dark:text-sky-300',
    chev: 'text-sky-400 group-hover:text-sky-600 dark:group-hover:text-sky-300',
  },
  /* [PATCH pregled-dela v4] */
  emerald: {
    card: 'bg-emerald-50 dark:bg-emerald-500/15 border-emerald-200 dark:border-emerald-500/30 hover:border-emerald-400 dark:hover:border-emerald-500/60',
    chip: 'bg-emerald-100 dark:bg-emerald-500/25 text-emerald-600 dark:text-emerald-300',
    chev: 'text-emerald-400 group-hover:text-emerald-600 dark:group-hover:text-emerald-300',
  },
};

export function SuperadminPage() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Superadmin</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">Upravljanje sistema</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'Baze', desc: 'Servisi, povpraševanja, premik, izbrisane', path: '/superadmin/baze', icon: Building2, color: 'violet' },
          { label: 'Poraba in prostor', desc: 'Azure OCR, LLM in prostor', path: '/superadmin/poraba', icon: BarChart3, color: 'sky' },
          { label: 'Pregled dela', desc: 'Aktivni čas in učinkovitost po računovodjah', path: '/superadmin/delo', icon: Timer, color: 'emerald' }, /* [PATCH pregled-dela v4] */
        ].map(({ label, desc, path, icon: Icon, color }) => (
          <button key={path} onClick={() => navigate(path)}
            className={`text-left rounded-2xl border p-5 hover:shadow-md transition group ${menuStyle[color].card}`}>
            <div className="flex items-center justify-between">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${menuStyle[color].chip}`}>
                <Icon className="w-5 h-5" />
              </div>
              <ChevronRight className={`w-5 h-5 transition ${menuStyle[color].chev}`} />
            </div>
            <p className="font-semibold text-gray-900 dark:text-white mt-3">{label}</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
